// extracted by mini-css-extract-plugin
export default {"header":"sQILOK+vWjnW7yLNgl+GdQ=="};